module.exports = __webpack_public_path__ + "static/media/microsoft-icon.11e797ed.svg";